import React, { useEffect, useState } from 'react';
import styles from './wendril_instrutor78_.module.scss';
import ImageLink1 from './src/1.png';
import ImageLink2 from './src/2.png';
import ImageLink3 from './src/3.png';
import ImageLink4 from './src/4.png';
import ImageLink5 from './src/5.png';
import ImageLink6 from './src/6.png';
import { Link } from 'react-router-dom';

const Wendril_instrutor78_: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={styles.wendril_instrutor78_}>
            <div className={styles.container}>
                <div className={`${styles.background} ${scrolled ? styles.blurred : ''}`} />
                <div className={styles.principalContent}>
                    <div className={styles.content}>
                        <h1 className="mb-2">Seja bem-vindo(a)!</h1>
                        <p className={`${styles.borderBottom} pb-2 mb-2`}><b>Essa página tem todos os links que você precisa para prosseguir.</b></p>
                        <p><b>Clique no destino desejado!</b></p>
                        <div className={styles.linksContainer}>
                            <Link to="/wendril_instrutor78_/localizacoes" className={styles.link}>
                                <img src={ImageLink1} alt="Link 1" />
                            </Link>
                            <a
                                href="https://www.instagram.com/wendril_instrutor78_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                target="_blank"
                                className={styles.link}>
                                <img src={ImageLink2} alt="Link 2" />
                            </a>
                            <Link to="/wendril_instrutor78_/fitdancekidsteen" className={styles.link}>
                                <img src={ImageLink3} alt="Link 3" />
                            </Link>
                            <a
                                href="https://wa.me/5517988120941?text=Olá, gostaria de mais informações referente à eventos de 15 anos | casamentos..."
                                target="_blank"
                                className={styles.link}>
                                <img src={ImageLink4} alt="Link 4" />
                            </a>
                            <a
                                href="https://wa.me/5517988120941?text=Olá, gostaria de mais informações referente ao serviço de Personal Dance..."
                                target="_blank"
                                className={`${styles.link} mb-4`}>
                                <img src={ImageLink5} alt="Link 5" />
                            </a>
                            <a
                                href="https://wa.me/5517988120941?text=Olá, gostaria de mais informações referente ao serviço de Dança de salão particular..."
                                target="_blank"
                                className={`${styles.link} mb-4`}>
                                <img src={ImageLink6} alt="Link 6" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Wendril_instrutor78_;